import getApiClient from '@/plugins/api'
import fileValidator from '@/helpers/fileValidator'

export default {
    loadData: function() {
        const self = this,
            api = getApiClient(self.$store)

        self.$store.commit('startLoading')

        let userId = self.$store.state.user.id

        api.get(`/user/${userId}`)
            .then(result => {
                self.user = Object.assign({}, result.data)
            })
            .catch(error => {
                console.log(error)
            })
            .finally(() => {
                self.$store.commit('stopLoading')
            })
    },

    openCropper(files, model) {
        const self = this
        const image = files[0]

        this.croppingModel = model

        const valid = fileValidator(image, {
            maximumSize: (1024 * 2000)
        })

        if (!valid.result) {
            alert(valid.message)
            return
        }

        const reader = new FileReader()
        reader.readAsDataURL(image)
        reader.onload = e => {
            self.croppingImage = e.target.result
            self.showCropper = true
        }
    },

    closeCropper() {
        this.croppingImage = null
        this.showCropper = false
        this.croppingModel = null
    },

    setImage() {
        const { canvas } = this.$refs.imageCropper.getResult()
        switch (this.croppingModel) {
            case 'picture':
                this.user.agency.picture = canvas.toDataURL('image/jpeg', 70)
                this.user.image = canvas.toDataURL('image/jpeg', 70)
                break;
            case 'cover':
                const result = canvas.toDataURL('image/jpeg', 70)
                this.user.agency.cover = result
                this.user.agencyCover = result
                break;
        }
        this.croppingImage = null
        this.showCropper = false
        this.croppingModel = null
    },

    showSuccessMessage() {
        this.success = true
    },
}
